import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength } from '@gig/magic-form-builder';
import { documentNumberTypes } from './document.utils.js';

function documentNumber() {
    return {
        id: 'document-number',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'document-number',
        properties: {
            placeholder: translate('verification-upload.document.number-label'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('verification-upload.document.number-required'),
            },
            {
                name: 'min-length',
                fn: minLength(1),
                message: translate('verification-upload.document.number-required'),
            },
            {
                name: 'max-length',
                fn: maxLength(20),
                message: translate('verification-upload.document.number-max'),
            },
        ],
        triggers: {
            'document-type': onTypeChange,
        },
        converter: function (formValue) {
            return { DocumentNumber: formValue['document-number'].value };
        },
    };
}
var onTypeChange = function (value, formData, setField) {
    var hidden = !documentNumberTypes.includes(value);
    setField({
        id: 'document-number',
        hidden: hidden,
    });
};

export { documentNumber };
